var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.448 3.5H3.552C3.24714 3.5 3 3.74714 3 4.052V9.948C3 10.2529 3.24714 10.5 3.552 10.5H9.448C9.75286 10.5 10 10.2529 10 9.948V4.052C10 3.74714 9.75286 3.5 9.448 3.5Z",
    stroke: "#3751FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.448 3.5H14.552C14.2471 3.5 14 3.74714 14 4.052V9.948C14 10.2529 14.2471 10.5 14.552 10.5H20.448C20.7529 10.5 21 10.2529 21 9.948V4.052C21 3.74714 20.7529 3.5 20.448 3.5Z",
    stroke: "#3751FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.448 14.5H3.552C3.24714 14.5 3 14.7471 3 15.052V20.948C3 21.2529 3.24714 21.5 3.552 21.5H9.448C9.75286 21.5 10 21.2529 10 20.948V15.052C10 14.7471 9.75286 14.5 9.448 14.5Z",
    stroke: "#3751FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.448 14.5H14.552C14.2471 14.5 14 14.7471 14 15.052V20.948C14 21.2529 14.2471 21.5 14.552 21.5H20.448C20.7529 21.5 21 21.2529 21 20.948V15.052C21 14.7471 20.7529 14.5 20.448 14.5Z",
    stroke: "#3751FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.fced5828d8c94fb03ed05911f8b0c635.svg";
export { ForwardRef as ReactComponent };